// extracted by mini-css-extract-plugin
export default {"primaryFont":"ItemMobile_primaryFont__uSSw8","secondaryFont":"ItemMobile_secondaryFont__9v4v+"};